import { Link } from '@tanstack/react-router';
import s from './Login.module.css';

export function NotFound() {
  return (
    <div className={s.root}>
      <main className={s.card} aria-labelledby="nfT">
        <h1 id="nfT" className={s.title}>Không tìm thấy trang</h1>
        <p className={s.sub}>Đường dẫn không tồn tại hoặc đã đổi.</p>
        <Link to="/" className={s.sso}>
          Về HANA Hub
        </Link>
      </main>
    </div>
  );
}
